var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information"},[_c('p',{class:{title:true, none:!(_vm.title)},domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{class:{text:true, inline:!(_vm.title)}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }